export const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
export const LOADING = 'LOADING';
export const SAVE_SEARCH_PARAM = 'SAVE_SEARCH_PARAM';
export const SAVE_PAGINATION_DATA = 'SAVE_PAGINATION_DATA';
export const SAVE_PORTAL_USER = 'SAVE_PORTAL_USER';
export const TABLE_LOADING = 'TABLE_LOADING';
export const  GET_BULK_TRANSACTIONS = 'GET_BULK_TRANSACTIONS';
export const  GET_BULK_TRANSACTIONS_BY_ID = 'GET_BULK_TRANSACTIONS_BY_ID';
export const  SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID = 'SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID';
export const  BULK_VIEW_LOADING = 'BULK_VIEW_LOADING';